module.exports = __webpack_public_path__ + "img/arrow-fill.96413543.svg";